import React from 'react';
import { useTranslation } from 'react-i18next';

// Brand-name strings — intentionally NOT translated (per spec §5).
const LOGOS = ['LimpaJá', 'ServiçosPro', 'ManutCenter', 'FixIt', 'CleanTeam', 'OS Trevora'];

export const TrustBarSection = React.memo(() => {
  const { t } = useTranslation();

  return (
    <section className="border-y border-gray-100 bg-gray-50/50 py-10">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs uppercase tracking-widest mb-8 text-gray-400">
          {t('landing.trustBar.title')}
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6 opacity-70">
          {LOGOS.map((name) => (
            <div key={name} className="text-base md:text-lg font-semibold tracking-tight text-gray-500">
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});
TrustBarSection.displayName = 'TrustBarSection';
